import { gql } from 'graphql-request'

export const QueryBlockSummary = gql`
  fragment FragmentBlockSummary on BlockSummaryModelRecord {
    __typename
      id
    preface
    title
  image {
    title
    url
    filename
    mimeType
    width
    height
    video {
      muxPlaybackId
      title
      width
      height
      blurUpThumb
    }
    responsiveImage {
      sizes
      src
      width
      height
      alt
      title
      base64
    }
  }
    simpleContentBlocks {
        ...FragmentSimpleBlock
      }
    theme
    imageBackgroundColor
  }
`
export const BlockSummary = {
  __typename: 'BlockSummary',
  fragmentName: 'FragmentBlockSummary',
  fragmentQuery: QueryBlockSummary,
  fragments: ['FragmentNavigationItem', 'FragmentSimpleBlock', 'FragmentFormattedTextBlock']
}
